<template>
  <div>
    <h1 class="page-header">Chart of Accounts</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-6">
            <ts-button outline color="info" @click="$router.push({ name: 'chart-of-account-create' })">
              Add New
            </ts-button>
          </div>
          <div class="col-sm-6 d-flex justify-content-end">
            <ts-input v-model="search" placeholder="Search" style="width: 300px;" class="kh-font" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template slot-scope="{ record }">
          <td>{{ record.account_number }}</td>
          <td>{{ record.account_name }}</td>
          <td>
            {{ record.account_type ? record.account_type.account_type : '' }}
          </td>
          <td>
            {{ record.parent_account ? record.parent_account.account_name : '' }}
          </td>
          <td>{{ $store.getters.limitStringShow(record.description) }}</td>
          <td class="text-center">
            <div class="checkbox checkbox-css">
              <input type="checkbox" id="is_sub_account" :checked="record.is_sub_account" disabled />
              <label for="is_sub_account"></label>
            </div>
          </td>
          <td class="text-center">
            <div class="checkbox checkbox-css">
              <input type="checkbox" id="inactive" :checked="record.inactive" disabled />
              <label for="inactive"></label>
            </div>
          </td>
          <td class="text-center">
            <router-link
              :to="{
                name: 'chart-of-account-edit',
                params: { id: record.account_id }
              }"
              title="edit"
              class="mr-2"
            >
              <i class="fas fa-edit"></i>
            </router-link>

            <a href="#" title="delete" class="text-danger" @click="destroy(record.account_id)">
              <i class="fas fa-trash"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"> </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'chart-of-account',
  data() {
    return {
      loading: false,
      columns: [
        { name: 'number', style: 'width: 8%' },
        { name: 'name', style: 'width: 15%' },
        { name: 'type', style: 'width: 15%' },
        { name: 'parent account', style: 'width: 15%' },
        { name: 'description' },
        { name: 'sub account', style: 'width: 10%' },
        { name: 'inactive', style: 'width: 5%' },
        { name: 'Actions', style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('accounting/chartOfAccount', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.accounting.chartOfAccount.search
      },
      set(newValue) {
        this.$store.commit('accounting/chartOfAccount/SET_SEARCH', newValue)
        this.$store.commit('accounting/chartOfAccount/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('accounting/chartOfAccount/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },

    async destroy(account_id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('accounting/chartOfAccount/destroy', account_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'chart-of-account-create') {
      this.$store.commit('accounting/chartOfAccount/RESET_STATE')
    }
    next()
  }
}
</script>
